const isDevMode = process.env.NODE_ENV === 'development';

const CATALOG_ARCHIVE_URL = '/upload/pictures/katalogi/ru_ru/catalog-all-latest.zip';
const CATALOG_PRICELIST_URL = '/products/price/';
const ITK_CATALOG_PRICELIST_URL = '/local/assets/pricelist/Price_ITK.xlsx';

const ITK_CATALOG_SPEC_PRICELIST_URL = '/produktsiya/prays-list/files/spec-price-itk.xlsx';

const ITK_CATALOG_ARCHIVE_URL = '/servis-i-podderzhka/katalogi-i-po/images/Catalog_ITK_new.pdf';
const GENERICA_BUILD_URL = isDevMode ? process.env.PUBLIC_URL + '/' : '/local/templates/.default/build/';
const GENERICA_SPRITE_URL = GENERICA_BUILD_URL + 'img/sprite.svg';

export const QR_CODE_SIZE = 150;

declare global {
    interface WindowYandexRotorSettings {
        WaiterEnabled?: boolean
        IsLoaded?: boolean
        IsError?: boolean
        FailOnTimeout?: boolean
        NoJsRedirectsToMain?: boolean
    }
    interface Window {
        _catalogSettings?: {
            baseApiUrl: string;
            template: string;
            lang: string;
            trademarks: string;
            baseRoute: string;
            site?: string;
        };
        YandexRotorSettings: WindowYandexRotorSettings;
    }
}

const BASE_API_URL = window._catalogSettings?.baseApiUrl || 'https://api-02.iek.ru/catalog/v1';
const TEMPLATE = window._catalogSettings?.template || 'new_iek';
const LANG = window._catalogSettings?.lang || 'ru';
const TRADEMARKS = window._catalogSettings?.trademarks || 'IEK';
const BASE_ROUTE = window._catalogSettings?.baseRoute || '/products/catalog';
const SITE = window._catalogSettings?.site;

export {
    BASE_API_URL,
    CATALOG_ARCHIVE_URL,
    CATALOG_PRICELIST_URL,
    ITK_CATALOG_PRICELIST_URL,
    ITK_CATALOG_SPEC_PRICELIST_URL,

    ITK_CATALOG_ARCHIVE_URL,
    GENERICA_BUILD_URL,
    GENERICA_SPRITE_URL,
    TEMPLATE,
    LANG,
    TRADEMARKS,
    BASE_ROUTE,
    SITE,
};
